import axios from "axios";
import {
  FETCH_CONFIG,
  CREATE_CONFIG,
  UPDATE_CONFIG,
  DELETE_CONFIG,
  DELETE_ALL_CONFIG,
  SET_DEFAULT_CONFIG,
  interceptor,
  UPDATE_HEADER,
  UPDATE_TAX_RATE,
  GET_CONFIG_BYNAME,
  UPDATE_DASHBOARD_BANNER,
  GET_DROPBOX_AUTHORIZED_URL,
} from ".";
import store from "../store";
// import { BASE_URL } from "../utils/helper";

interceptor(axios, store);

export function addConfig(config) {
  return {
    type: CREATE_CONFIG,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/config/`, config, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function fetchConfig() {
  return {
    type: FETCH_CONFIG,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/config/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateConfig(name, data) {
  return {
    type: UPDATE_CONFIG,
    payload: axios.put(`${process.env.REACT_APP_API_ENDPOINT}/core/config/${name}`, data, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteConfig(id) {
  return {
    type: DELETE_CONFIG,
    payload: axios.delete(`${process.env.REACT_APP_API_ENDPOINT}/core/config/${id}`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function deleteAllConfig() {
  return {
    type: DELETE_ALL_CONFIG,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/config/deleteAll/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function setDefaultConfig() {
  return {
    type: SET_DEFAULT_CONFIG,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/config/default/`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}

export function updateHeader(image) {
  const config = {
    headers: {
      "content-type": undefined,
      Authorization: store.getState().cognito.token,
      PetShopId: store.getState().petShopReducer.currentPetshop.id
    }
  };

  return {
    type: UPDATE_HEADER,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/updateHeader/${
        store.getState().petShopReducer.currentPetshop.id
      }`,
      image,
      config
    )
  };
}

export function updateTaxRate(value) {
  const config = {
    headers: {
      "content-type": undefined,
      Authorization: store.getState().cognito.token,
      PetShopId: store.getState().petShopReducer.currentPetshop.id
    }
  };

  return {
    type: UPDATE_TAX_RATE,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/updateTaxRate/${
        store.getState().petShopReducer.currentPetshop.id
      }`,
      { tax_rate: value },
      config
    )
  };
}

export function getConfigByName(data) {
  return {
    type: GET_CONFIG_BYNAME,
    payload: axios.post(`${process.env.REACT_APP_API_ENDPOINT}/core/config/getbyname`,data,{
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}


export function updateDashboardBanner(userRole,image) {
  return {
    type: UPDATE_DASHBOARD_BANNER,
    payload: axios.post(
      `${process.env.REACT_APP_API_ENDPOINT}/core/pet_shop/updateDahsboardBanner/${userRole}`,
      image,
      {
        headers: {
          Authorization: store.getState().cognito.token,
          PetShopId: store.getState().petShopReducer.currentPetshop.id
        }
      }
    )
  };
}

export function getDropboxAuthorizedUrl() {
  return {
    type: GET_DROPBOX_AUTHORIZED_URL,
    payload: axios.get(`${process.env.REACT_APP_API_ENDPOINT}/core/contract/auth/getAuthorizedUrl`, {
      headers: {
        Authorization: store.getState().cognito.token,
        PetShopId: store.getState().petShopReducer.currentPetshop.id
      }
    })
  };
}
